import type { Puzzle } from '../types';
import { $ } from './dom';

// Back-banner cycle — decoupled from per-movie attribution so the box reads as
// a genre-anthology release rather than an in-fiction studio credit.
const GENRE_TAGS = [
  'A SLASHER CLASSIC',
  'MIDNIGHT HORROR PRESENTATION',
  'A GRINDHOUSE TERROR',
  'AN AFTER-HOURS SCREAMER',
  'A CULT B-MOVIE',
  'VHS HORROR PRESENTS',
] as const;

export function renderMovie(puzzle: Puzzle): void {
  const m = puzzle.movie;

  // Front face
  const nameEl = $('ghost-name');
  nameEl.textContent = m.name;
  // Tier the title font for longer names so they wrap cleanly without
  // running under the rating + Hi-Fi badge column.
  nameEl.classList.remove('cover-title--long', 'cover-title--xl');
  if (m.name.length >= 22) nameEl.classList.add('cover-title--xl');
  else if (m.name.length >= 17) nameEl.classList.add('cover-title--long');

  $('ghost-year').textContent = String(m.year);
  $('ghost-catchphrase').textContent = m.catchphrase ? `"${m.catchphrase}"` : '';
  if (m.icon) {
    $('cover-icon').textContent = m.icon;
    // Mobile movie button doubles as a thumbnail of tonight's rental.
    $('movie-btn').textContent = m.icon;
  }

  // Back face
  $('ghost-name-back').textContent = m.name;
  $('ghost-cause-back').textContent = m.cause ? `Starring ${m.cause}` : '';
  $('back-banner-text').textContent = GENRE_TAGS[puzzle.dayIndex % GENRE_TAGS.length]!;
  $('ghost-synopsis').textContent = m.synopsis;

  // Per-movie cover-art palette.
  const box = $('vhs-box');
  if (m.palette.length >= 2) {
    box.style.setProperty('--cover-1', m.palette[0]);
    box.style.setProperty('--cover-2', m.palette[1]);
  }
}

export function installFlipHandler(): void {
  const box = $('vhs-box');
  const toggle = () => box.classList.toggle('flipped');
  box.addEventListener('click', toggle);
  box.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      toggle();
    }
  });
}
